import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setKcRoles } from './SharedModules/store/Actions/SharedAction';
import { jwtDecode } from 'jwt-decode';
import Keycloak from 'keycloak-js';
import { safeLocationRedirect } from './SharedModules/CommonUtilities/safeWindowOpen';

function Login(props) {
  const dispatch = useDispatch();
  const keyCloakOptions = {
    realm: process.env.REACT_APP_SSO_REALM,
    url: process.env.REACT_APP_SSO_URL,
    clientId: process.env.REACT_APP_SSO_CLIENT_ID,
  };

  const [keycloak, setKeycloak] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const parseRoles = (roles) => {
    const prefix = 'FRR_';

    if (Array.isArray(roles)) {
      return roles.map((role) => {
        let roleParse = role.split(',')[0].split('=')[1];
        return roleParse.startsWith(prefix)
          ? roleParse.slice(prefix.length)
          : roleParse;
      });
    }

    if (roles) {
      let roleParse = roles.split(',')[0].split('=')[1];
      const parsedRole = roleParse.startsWith(prefix)
        ? roleParse.slice(prefix.length)
        : roleParse;
      return [parsedRole];
    }

    return null;
  };
  const initiateLogin = () => {
    const ssoSamlUrl = process.env.REACT_APP_SSO_SAML_URL;
    if (!safeLocationRedirect(ssoSamlUrl)) {
      console.error('Blocked untrusted SSO redirect URL');
    }
  };
  const checkAuthFromCallback = () => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    // let cookies;
    // try{
    //   if(document.cookie) {
    //   cookies = document.cookie.split(';').reduce((acc,cookie) => {
    //   const [key, value] = cookie.split('=');
    //   acc[key] = value;
    //   return acc;
    // }, {});
    // }
    // }catch(err){
    //   console.log(err);
    // }
    // const token = cookies?.accessToken;
    if (token) {
      // console.log('TOKEN:', token, JSON.parse(token), jwtDecode(JSON.parse(token)))
      const decodedToken = jwtDecode(token);

      if (decodedToken && decodedToken.uid && decodedToken.roles) {
        // console.log('decodedtoken', decodedToken.roles);
        // console.log('pasrseRoles', parseRoles(decodedToken.roles));
        const parsedRoles = parseRoles(decodedToken.roles);
        setIsAuthenticated(true);
        const userProfile = {
          uid: decodedToken.uid,
          roles: parsedRoles,
        };
        dispatch(setKcRoles({ userPrivileges: parsedRoles }));
        // console.log(parsedRoles)
        props.setLoginDoneSAML(userProfile);
      }
    } else if (params.get('err') === 'true') {
      console.error('Authentication failed');
    } else {
      initiateLogin();
    }
  };
  useEffect(() => {
    if (process.env.REACT_APP_FORGEROCK_SAML_SSO) checkAuthFromCallback();
  }, [location]);
  useEffect(() => {
    if (!process.env.REACT_APP_FORGEROCK_SAML_SSO) {
      const keycloakInstance = new Keycloak(keyCloakOptions);
      keycloakInstance
        .init({ onLoad: 'login-required' })
        .then((authenticated) => {
          setKeycloak(keycloakInstance);
          setIsAuthenticated(authenticated);
          const kcRoles = {
            userPrivileges:
              keycloakInstance?.tokenParsed?.resource_access[
                keycloakInstance?.clientId
              ]?.roles,
          };
          dispatch(setKcRoles(kcRoles));
          props.setLoginDone(keycloakInstance);
        });
    }
  }, []);

  return isAuthenticated && '';
}

export default withRouter(Login);
